import { Component, Input, OnInit, ViewChild, Renderer2, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import * as d3 from "d3";

@Component({
  selector: 'app-map-open-data',
  templateUrl: './map-open-data.component.html',
  styleUrls: ['./map-open-data.component.scss']
})
export class MapOpenDataComponent implements OnInit {
  map: any;
  layerGroup: any;
  layerGroupShapes: any;
  filteredSedes: any = [];
  groupByShapes: any = [];
  groupByAlcaldia: any = [];
  groupByEnte: any = [];
  groupBySede: any = [];

  nombre: string;
  countMujer: number = 0;
  countHombre: number = 0;
  sueldo_promedio: number = 0;

  chart_div: any;

  private svg;
  private g;

  obj: any = [];

  custom: any;

  @Input() sedes: any = {};
  @Input() fullData: any = [];
  // @Output() toggle = new EventEmitter<Object>();

  @ViewChild('primaryMap', {static: true}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;

    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    this.map = L.map('primaryMap', { scrollWheelZoom: false }).setView([19.329209, -99.018432], 11);

    // 19.369903, -99.148074
    // L.ZoomControl({ postion: 'bottomright' }).addTo(this.map);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    // INIT layerGroups
    this.layerGroup = L.layerGroup().addTo(this.map);
    this.layerGroupShapes = L.layerGroup().addTo(this.map);

  }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes.sedes.currentValue.message) {
      await this.generateFilters(this.sedes);
      await this.buildMap(this.groupByShapes);
      // await this.buildInfoBlocks(this.sedes);
      // await this.processInfoBlock();
    }
    console.log("CHANGES => ", changes)
  }

  private async generateFilters (sedes: any) {
    let filters: any = {};

    this.filteredSedes = sedes;
    this.obj = this.groupBy(sedes.filters, "nombre");

    this.groupByShapes = [...new Set(sedes.filters.map(item => item.geo_shape))];
    this.groupByAlcaldia = [...new Set(sedes.filters.map(item => item.nombre))];

    let mujeres = sedes.filters.filter(el => el.sexo == "Mujer");
    let hombres = sedes.filters.filter(el => el.sexo == "Hombre");

    await mujeres.map(item => this.countMujer += item.numero );
    await hombres.map(item => this.countHombre += item.numero );

    sedes.filters.map(item => item.nombre);
  }

  generateCounters() {

    this.nombre = "CDMX";

    let sueldo = this.sedes.filters.reduce((a, b) => ({promedio_sueldo_tabular_bruto: a.promedio_sueldo_tabular_bruto + b.promedio_sueldo_tabular_bruto }) )

    this.sueldo_promedio = sueldo.promedio_sueldo_tabular_bruto / this.sedes.filters.length;
    this.sedes.filters.filter(el => el.sexo == "Mujer" ? this.countMujer++ : this.countHombre++)
  }

  buildInfoBlocks(sedes) {
    let nombre: string = sedes.filters[0].nombre;
    let countMujer: number = 0;
    let countHombre: number = 0;
    let arr = sedes.filters;

    let sueldo = arr.reduce((a, b) => ({promedio_sueldo_tabular_bruto: a.promedio_sueldo_tabular_bruto + b.promedio_sueldo_tabular_bruto }) )
    let sueldo_promedio = sueldo.promedio_sueldo_tabular_bruto / arr.length;

    arr.filter(el => el.sexo == "Mujer" ? countMujer++ : countHombre++)
    let totalEmpleados = arr.reduce((a, b) => ({ numero:  a.numero + b.numero }) )

    this.chart_div = L.DomUtil.create('div', 'chartInfo');
    this.chart_div.setAttribute("id", "chartInfo");

    let chartInfo = new L.Control();
    // chartInfo.onAdd = () => {
      // this.return this.chart_div;
    // }

    this.chart_div.innerHTML = `
      <h1 style="font-size: 1.6em !important;">Recursos humanos de alcaldías diciembre 2020 </h1>
      <p class="mb-0">Alcaldía</p>
      <h2>${this.nombre}</h2>
      <p class="mb-0 mt-2">Total mujeres:</p>
      <h2>${this.countMujer}</h2>
      <p class="mb-0 mt-2">Total hombres:</p>
      <h2>${this.countHombre}</h2>
      <p class="mb-0 mt-2">Promedio salarial</p>
      <h2>$${Number(this.sueldo_promedio).toFixed(2)}</h2>
    `;

    // chartInfo.addTo(this.map);

    const chartContainer = this.renderer.createElement('svg');

    chartContainer.setAttribute("id", "chart");
    // this.renderer.appendChild(document.getElementById("chartInfo"), chartContainer);
  }

  groupBy (collection, property) {
    var i = 0, val, index,
        values = [], result = [];
    for (; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1)
            result[index].push(collection[i]);
        else {
            values.push(val);
            result.push([collection[i]]);
        }
    }
    return result;
  }

  private buildObjs () {

  }

  private async buildMap (sedes) {
    let controller = this;

    let iconMarker = L.icon({
      iconUrl: 'marker-icon.png'
    });

    let polyStyle = {
      default: {
        "color": "#1D4439",
        "fillColor": "#8DB85D",
        "weight": 2
      },
      selected: {
        "color": "#fff",
        "fillColor": "#0097A7",
        "weight": 2
      },
      hovered: {
        "color": "#8DB85D",
        "fillColor": "#1D4439",
        "weight": 2,
        "fillOpacity": 1
      }
    }

    let info = new L.Control({ position: "bottomleft" });

    info.onAdd = function (map) {
      this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
      this._div.innerHTML = `
        <h4 style="color: #545454 !important;">Total de empleados por Alcaldía</h4>
      `;

      let grades: any = [
        { "color": "#a6e61c", "quintil": "Empleados", "max": "2,827" },
        { "color": "#91d400", "quintil": "Empleados", "max": "4,500" },
        { "color": "#00843d", "quintil": "Empleados", "max": "6,000" },
        { "color": "#1a6334", "quintil": "Empleados", "max": "9,000" },
        { "color": "#0f4c42", "quintil": "Empleados", "max": "10,532" }
      ];

      grades.map((grade) => {
        this._inner = L.DomUtil.create('div', 'list');
        this._inner.innerHTML = `
          <div class="clearfix">
            <div class="square" style="background-color: ${grade.color}"></div>
            <div style="float:left; margin-left: 6px; width: 80%;">${grade.quintil} -> ${grade.max ? grade.max : ""}</div>
          </div>
        `;
        this._div.append(this._inner)
      });

      return this._div;
    };

    info.addTo(this.map);

    this.obj.map(async (arr) => {
      let mujeres = arr.filter(el => el.sexo == "Mujer");
      let hombres = arr.filter(el => el.sexo == "Hombre");
      let countMujer: number = 0;
      let countHombre: number = 0;

      await mujeres.map(item => countMujer += item.numero );
      await hombres.map(item => countHombre += item.numero );

      let prct = (countMujer * 100 / this.countMujer) / 10;

      let total = countMujer + countHombre;
      let color = "";

      if (total <= 2827) {
        color = '#a6e61c';
      } else if (total > 2827 && total <= 4500) {
        color = '#91d400';
      } else if (total > 4500 && total <= 6000) {
        color = '#00843d';
      } else if (total > 6000 && total <= 9000) {
        color = '#1a6334';
      } else if (total > 9000) {
        color = '#0f4c42';
      }

      L.geoJSON(JSON.parse(arr[0].geo_shape), {
        style: {
          "color": "#1D4439",
          "fillColor": color,
          "weight": 2,
          "fillOpacity": 1
        },
      }).on('click', function (e) {

      }).on('mouseout', function (e) {
        e.layer.unbindTooltip();
      }).on('mouseover', function (e) {
        e.layer.bindTooltip(`
          <div style="background: #ddd; color: black; padding: 8px; border-radius: 8px; ">
            <h3 style="color: #545454 !important;">${arr[0].nombre}</h3>
            <p style="color: #545454;">Total de empleados</p>
            <span style="color: #545454 !important;">Total Mujeres: ${countMujer}</span><br>
            <span style="color: #545454 !important;">Total Hombres: ${countHombre}</span>
          </div>
        `, { closeButton: true });

      }).addTo(this.layerGroupShapes);
    });
  }

  private async processInfoBlock() {
    let div = L.DomUtil.create('div', 'info');
    div.setAttribute("id", "selectInfo")
    let info = new L.Control();
    info.onAdd = () => {
      return div;
    }

    info.addTo(this.map);

    const selectContainer = this.renderer.createElement('div');
    const select = this.renderer.createElement("select");

    select.setAttribute("class", "form-control")
    select.addEventListener('change', (event) => {
      let nombre: string = event.target.value;
      let countMujer: number = 0;
      let countHombre: number = 0;

      let arr = this.obj[0];

      let sueldo = arr.reduce((a, b) => ({promedio_sueldo_tabular_bruto: a.promedio_sueldo_tabular_bruto + b.promedio_sueldo_tabular_bruto }) )
      let sueldo_promedio = sueldo.promedio_sueldo_tabular_bruto / arr.length;

      arr.filter(el => el.sexo == "Mujer" ? countMujer++ : countHombre++)
      let totalEmpleados = arr.reduce((a, b) => ({ numero:  a.numero + b.numero }) )

      this.chart_div.innerHTML = `
        <h1 style="font-size: 1.6em !important;">Recursos humanos de alcaldías diciembre 2020 </h1>
        <p class="mb-0">Alcaldía</p>
        <h2>${nombre}</h2>
        <p class="mb-0 mt-2">Total mujeres:</p>
        <h2>${countMujer}</h2>
        <p class="mb-0 mt-2">Total hombres:</p>
        <h2>${countHombre}</h2>
        <p class="mb-0 mt-2">Promedio salarial</p>
        <h2>$${Number(sueldo_promedio).toFixed(2)}</h2>
      `;
    });

    selectContainer.appendChild(select);

    this.groupByAlcaldia.map((item) => {
      let opt = this.renderer.createElement("option");
      opt.value = item;
      opt.innerHTML = item;
      select.appendChild(opt);
    });

    selectContainer.setAttribute("id", "selectContainer");
    // this.renderer.appendChild(document.getElementById("selectInfo"), selectContainer);
  }
}
